// Country Enums ---------------------------------------------------------------------------------------------------------------------------

export enum CountryFields {
  Abbrev2 = "abbrev_2",
  Abbrev3 = "abbrev_3",
  CreatedAt = "created_at",
  Id = "id",
  Name = "name",
  NumericCode = "numeric_code",
  StateName = "state_name",
  UpdatedAt = "updated_at",
}

// Country interfaces ----------------------------------------------------------------------------------------------------------------------

export interface Country {
  [CountryFields.Abbrev2]: string;
  [CountryFields.Abbrev3]: string;
  [CountryFields.CreatedAt]: string | null;
  [CountryFields.Id]: number;
  [CountryFields.Name]: string;
  [CountryFields.NumericCode]: string;
  [CountryFields.StateName]: string;
  [CountryFields.UpdatedAt]: string | null;
}

export interface CountryCrud {
  [CountryFields.Abbrev2]: string;
  [CountryFields.Abbrev3]: string;
  [CountryFields.Id]: number | null;
  [CountryFields.Name]: string;
  [CountryFields.NumericCode]: string;
  [CountryFields.StateName]: string;
}

export interface CountryDetail {
  [CountryFields.Abbrev2]: string;
  [CountryFields.Abbrev3]: string;
  [CountryFields.CreatedAt]: string | null;
  [CountryFields.Id]: number;
  [CountryFields.Name]: string;
  [CountryFields.NumericCode]: string;
  [CountryFields.StateName]: string;
  [CountryFields.UpdatedAt]: string | null;
}
